export const ChangeOrderFieldLabels = {
  name: 'Name',
  description: 'Description',
  typeOfChange: 'Type of Change',
  urgentChange: 'Urgent Change',
  reasonForChange: 'Reason for Change',
  requestDate: 'Request Date',
  requestor: 'Requestor',
  impactOfChange: 'Impact of Change',
  changeToTrainingMatrix: 'Change to Training Matrix',
  comments: 'Comments',
  assetInventoryNeedUpdated: 'Asset Inventory Update',
  accessMatrixNeedUpdated: 'Access Matrix Update',
  requireRiskAssessment: 'Require Risk Management',
  requireAssetDowntime: 'Require Asset Downtime',
  itDueDate: 'IT Due Date',
  itCompletedDate: 'IT Completed Date',
  itComments: 'IT Comments',
  openPo: 'Open Po',
  incomingInspection: 'Incoming Inspection',
  wip: 'WIP',
  fg: 'FG',
  quarantineOrHold: 'Quarantine Or Hold',
  field: 'Field',
  invDueDate: 'Inventory Due Date',
  invCompletedDate: 'Inventory Completed Date',
  commentsInventory: 'Comments Inventory',
  fieldActionReview: 'Field Action Review',
  hazardAssessmentReview: 'Hazard Assessment Review',
  designVerificationReview: 'Design Verification Review',
  designReviewAttached: 'Design Review Attached',
  changeCompatibility: 'Change Compatibility',
  manufacturingQualityImpact: 'Manufacturing Quality Impact',
  changeSupplierImpact: 'Change Supplier Impact',
  productRegulatoryImpact: 'Product Regulatory Impact',
  changeSoftwareModification: 'Change Software Modification',
  dhfiUpdated: 'DHFI Updated',
  productDueDate: 'Product Due Date',
  productCompletedDate: 'Product Completed Date',
  commentsProduct: 'Comments Product',
  labelingReview: 'Labeling Review',
  regulatoryRegistrationAffected: 'Regulatory Registration Affected',
  claimsAffected: 'Claims Affected',
  udiAffected: 'UDI Affected',
  printedLabelImpact: 'Printed Label Impact',
  labelProgramUpdated: 'Label Program Updated',
  testLabelAttached: 'Test Label Attached',
  lblDueDate: 'Labeling Due Date',
  lblCompletedDate: 'Labeling Completed Date',
  commentsLabeling: 'Comments Labeling',
  processValidationImpact: 'Process Validation Impact',
  pfmeaImpact: 'PFMEA Impact',
  procedureImpact: 'Procedure Impact',
  safetyImpact: 'Safety Impact',
  sdsNeeded: 'SDS Needed',
  equipmentImpact: 'Equipment Impact',
  calibrationImpact: 'Calibration Impact',
  manufacturingRegulatoryImpact: 'Manufacturing Regulatory Impact',
  clinicalTrialImpact: 'Clinical Trial Impact',
  manufacturingDueDate: 'Manufacturing Due Date',
  manufacturingCompletedDate: 'Manufacturing Completed Date',
  commentsManufacturing: 'Comments Manufacturing',
  supplierEvaluationCompleted: 'Supplier Evaluation Completed',
  ndaApplicable: 'NDA Applicable',
  supplierAgreementNeeded: 'Supplier Agreement Needed',
  termsConditionsImpact: 'terms Conditions Impact',
  firstArticleRequired: 'First Article Required',
  inspectionProcedureImpact: 'Inspection Procedure Impact',
  supplierDueDate: 'Supplier Due Date',
  supplierCompletedDate: 'Supplier Completed Date',
  commentsSupplier: 'Comments Supplier',
  triggeredPeriodicReview: 'Triggered Periodic Review',
  qualityChangeComponent: 'Quality Change Component',
  qualityChangeArchitecture: 'Quality Change Architecture',
  qualityChangeRequiredInput: 'Quality Change Required Input',
  qualityChangeNewDiagnostic: 'Quality Change New Diagnostic',
  qualityChangePresentation: 'Quality Change Presentation',
  qualityChangeDataRequired: 'Quality Change Data Required',
  qualityChangeRisks: 'Quality Change Risks',
  qualityChangeIntendedUse: 'Quality Change Intended Use',
  documentInteraction: 'Document Interaction',
  regulationAssessment: 'Regulation Assessment',
  qualityRegulatoryDueDate: 'Quality Regulatory Due Date',
  qualityRegulatoryCompletedDate: 'Quality Regulatory Completed Date',
  commentsQualityDocument: 'Comments Quality Document',
  documentInteractionDescription: 'Document Interaction Description',
  ehsAssessmentDescription: 'EHS Assessment Description',
  regulationAssessmentOther: 'Regulation Assessment Other',
  otherAssessmentDueDate: 'Other Assessment Due Date',
  otherAssessmentCompletedDate: 'Other Assessment Completed Date',
  commentsOther: 'Comments Other',
  implementationNotes: 'Implementation Notes',
  implementationDueDate: 'Implementation Due Date',
  implementationCompletedDate: 'Implementation Completed Date',
  verificationNotes: 'Verification Notes',
  verificationDueDate: 'Verification Due Date',
  verificationCompletedDate: 'Verification Completed Date',
  attachment: 'Attachments',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  taskFileVersions: 'Document Version References',
  trainingMatrixNeedUpdated: 'Training Matrix Need Updated',
  changeImpactCompetencyAssessmentRequirements:
    'Change Impact Competency Assessment Requirements',
  changeRequireOperatorQualifications: 'Change Require Operator Qualifications',
  changeRequireOperatorOrTrainingCertification:
    'Change Require Operator Or Training Certification',
  affectedParts: 'Affected Parts',
  productDesignAssessment: 'Product Design Assessment',
  productRiskAssessment: 'Product Risk Assessment',
  affectedDocuments: 'Affected Documents',
  regulatoryAssessment: 'Regulatory Assessment',
  qualityAssessment: 'Quality Assessment',
  labellingAssessment: 'Labelling Assessment',
  manufacturingAssessment: 'Manufacturing Assessment',
  supplierAssessment: 'Supplier Assessment',
  clinical: 'Clinical',
  reviewAndApproveChangeComments: 'Review And Approve Change',
  productDesignActions: 'Product Design Actions',
  productRiskActions: 'Product Risk Actions',
  regulatoryActions: 'Regulatory Actions',
  qualityActions: 'Quality Actions',
  labellingActions: 'Labelling Actions',
  manufacturingActions: 'Manufacturing Actions',
  supplierActions: 'Supplier Actions',
  itSystemsActions: 'IT Systems Actions',
  verifyEffectiveness: 'Verify Effectiveness',
  changeRecordsAndDocumentationUpdated:
    'Change Records And Documentation Updated'
} as const;

export type ChangeOrderField = keyof typeof ChangeOrderFieldLabels;

export const ChangeOrderFields: ChangeOrderField[] = Object.keys(
  ChangeOrderFieldLabels
) as ChangeOrderField[];
